import {lazy, Suspense} from 'react';
import {FunctionComponent} from 'react';
import {useRoutes} from 'react-router-dom';
import {LandingTemplate} from './layout';
import UnsubscribeVerificationResponse from './shared/component/EmailNotificationSubscription/UnsubscribeResponse';

const HealthStatusPage = lazy(() => import('./presentation/HealthStatus/HealthStatusPage'));
const IncidentHistoryPage = lazy(
  () => import('./presentation/IncidentHistory/IncidentHistoryPage')
);

export const AppRoutes: FunctionComponent = (): any => {
  return useRoutes([
    {
      path: '',
      element: <LandingTemplate />,
      children: [
        {
          path: '',
          element: (
            <Suspense fallback={''}>
              <HealthStatusPage />
            </Suspense>
          ),
        },
        {
          path: 'history/:service',
          element: (
            <Suspense fallback={null}>
              <IncidentHistoryPage />
            </Suspense>
          ),
        },
        {
          path: 'subscription/confirm/',
          element: (
            <Suspense fallback={''}>
              <HealthStatusPage />
            </Suspense>
          ),
        },
        {
          path: 'subscription/unsubscribe/:id',
          element: (
            <Suspense fallback={''}>
              <HealthStatusPage />
              <UnsubscribeVerificationResponse />
            </Suspense>
          ),
        },
      ],
    },
  ]);
};
